import { Image } from "@chakra-ui/react";

import logo from "~/logo.svg";

export const Logo = () => {
  return <Image top="0" left="0" w="300px" alt="Logo" src={logo} />;
};
